import React, { lazy } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Loadable from '../ui-component/Loadable';
import MainLayout from '../layout';
import AuthGuard from '../utils/route-guard/AuthGuard';

// Lazy imports
const LandingPage = Loadable(lazy(() => import('../views/pages/LandingPage')));
const Logout = Loadable(lazy(() => import('../views/pages/authentication/Logout')));
const ScriptReport = Loadable(lazy(() => import('../components/ScriptReport')));
const LogReport = Loadable(lazy(() => import('../components/LogReport')));
const ContinuityReport = Loadable(lazy(() => import('../components/ContinuityReport')));
const CameraReport = Loadable(lazy(() => import('../components/CameraReport')));
const SoundReport = Loadable(lazy(() => import('../components/SoundReport')));
const SceneView = Loadable(lazy(() => import('../components/SceneView')));
const DataValidationReport = Loadable(lazy(() => import('../components/DataValidationReport')));
const VideoManagementData = Loadable(lazy(() => import('../components/VideoManagementData')));
const ProgressStatusList = Loadable(lazy(() => import('../components/ProgressStatusList')));
const UploadMovieAssets = Loadable(lazy(() => import('../components/UploadMovieAssets')));
const UserProfileList = Loadable(lazy(() => import('../components/UserProfileList')));
const OrganizationProfileList = Loadable(lazy(() => import('../components/OrganizationProfileList')));

const MainRoutes = () => {
  const location = useLocation();
  const path = location.pathname;

  const isVideoFile = /\.(mp4|mov)$/i.test(path.split('?')[0]);

  if (isVideoFile) {
    return;
  }

  return (
    <MainLayout>
      <AuthGuard>
        <Routes>
          <Route path="/dashboard" element={<LandingPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/script_report" element={<ScriptReport />} />
          <Route path="/log_report" element={<LogReport />} />
          <Route path="/continuity_report" element={<ContinuityReport />} />
          <Route path="/camera_report" element={<CameraReport />} />
          <Route path="/sound_report" element={<SoundReport />} />
          <Route path="/scene_view" element={<SceneView />} />
          <Route path="/data_validation_report" element={<DataValidationReport />} />
          <Route path="/video_management_data" element={<VideoManagementData />} />
          <Route path="/progress_status_list" element={<ProgressStatusList />} />
          <Route path="/upload_movie_asstes" element={<UploadMovieAssets />} />
          <Route path="/user_profile_list" element={<UserProfileList />} />
          <Route path="/organization_profile_list" element={<OrganizationProfileList />} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthGuard>
    </MainLayout>
  );
};

export default MainRoutes;
